// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-4fcb4534]::-webkit-inner-spin-button,input[data-v-4fcb4534]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-4fcb4534]{-moz-appearance:textfield}.p-button-black[data-v-4fcb4534]{color:#212529!important}", ""]);
// Exports
module.exports = exports;
